import React, { useCallback } from "react";
import JamezzTableV2, { useReloadState } from "../../components/JamezzTable/V2/JamezzTableV2";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import { Checkbox, Grid, TableCell } from "@mui/material";
import { BarChart } from "@mui/icons-material";
import { useWatch } from "react-hook-form";
import { formatTime } from "../../licensing/utils/formatDate";

export default function ScheduledTaskMetrics() {
  const { reloadState, updateReloadState } = useReloadState();
  const scheduledTaskId = useWatch({ name: "id" });

  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },
      {
        id: "started_at",
        label: <TranslationWrapper tDefault={"Started at"} tKey={"scheduledTaskMetrics.startedAt"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "finished_at",
        label: <TranslationWrapper tDefault={"Finished at"} tKey={"scheduledTaskMetrics.finishedAt"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "success",
        label: <TranslationWrapper tDefault={"Success"} tKey={"scheduledTaskMetrics.success"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell>{formatTime(new Date(row.started_at))}</TableCell>
        <TableCell>{row.finished_at ? formatTime(new Date(row.finished_at)) : "-"}</TableCell>
        <TableCell>
          <Checkbox checked={row.success} color={"primary"} disabled />
        </TableCell>
      </>
    );
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <JamezzTableV2
          checkboxSelection={true}
          dense={true}
          endPoint={"core/scheduledTaskMetrics"}
          filters={{ scheduledTaskId: { field: "scheduled_task_id", operator: "=", value: scheduledTaskId } }}
          headerIcon={<BarChart />}
          reloadState={reloadState}
          renderCellsForRow={renderRowCells}
          renderHeaderCells={renderHeaderCells}
          renderRowActions={() => []}
          renderSelectionActions={() => {}}
          tableTitle={<TranslationWrapper tDefault={"Scheduled Tasks"} tKey={"scheduledTasks.table.title"} />}
        />
      </Grid>
    </Grid>
  );
}
